'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var themeTools = require('@chakra-ui/theme-tools');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty__default["default"](target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
var parts = ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption'];
var baseStyle = {
  table: {
    fontVariantNumeric: 'lining-nums tabular-nums',
    borderCollapse: 'collapse',
    width: 'full'
  },
  th: {
    textStyle: 'heading',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: 'wider',
    textAlign: 'start'
  },
  td: {
    textAlign: 'start'
  },
  caption: {
    mt: 4,
    fontFamily: 'heading',
    textAlign: 'center',
    fontWeight: 'medium'
  }
};
var numericStyles = {
  '&[data-is-numeric=true]': {
    textAlign: 'end'
  }
};
var simpleVariant = function simpleVariant(props) {
  var c = props.colorScheme;
  return {
    th: _objectSpread({
      color: "gray.400",
      borderBottom: '1px',
      borderColor: c === 'blue' ? 'gray.200' : "".concat(c, ".200")
    }, numericStyles),
    td: _objectSpread({
      borderBottom: '1px',
      borderColor: c === 'blue' ? 'gray.100' : "".concat(c, ".100")
    }, numericStyles),
    caption: {
      color: "gray.600"
    },
    tfoot: {
      tr: {
        '&:last-of-type': {
          th: {
            borderBottomWidth: 0
          }
        }
      }
    }
  };
};
var stripedVariant = function stripedVariant(props) {
  var c = props.colorScheme,
    theme = props.theme;
  var simpleVariantStyles = simpleVariant(props);
  return _objectSpread(_objectSpread({}, simpleVariantStyles), {}, {
    tbody: {
      tr: {
        '&:nth-of-type(odd)': {
          td: {
            borderColor: c === 'blue' ? 'gray.100' : "".concat(c, ".100"),
            background: c === 'blue' ? themeTools.transparentize('gray.300', 0.125)(theme) : "".concat(c, ".100")
          }
        }
      }
    }
  });
};
var variants = {
  simple: simpleVariant,
  striped: stripedVariant,
  unstyled: {}
};
var sizes = {
  sm: {
    th: {
      px: '4',
      py: '1',
      lineHeight: '4',
      fontSize: 'sm'
    },
    td: {
      px: '4',
      py: '2',
      lineHeight: '4'
    },
    caption: {
      px: '4',
      py: '2',
      fontSize: 'sm'
    }
  },
  md: {
    th: {
      px: '6',
      py: '3',
      fontSize: 'md'
    },
    td: {
      px: '6',
      py: '4',
      lineHeight: '5'
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: 'md'
    }
  },
  lg: {
    th: {
      px: '8',
      py: '4',
      lineHeight: '5',
      fontSize: 'md'
    },
    td: {
      px: '8',
      py: '5',
      lineHeight: '6'
    },
    caption: {
      px: '6',
      py: '2',
      fontSize: 'lg'
    }
  }
};
var defaultProps = {
  variant: 'simple',
  size: 'md',
  colorScheme: 'blue'
};
var Table = {
  parts: parts,
  baseStyle: baseStyle,
  variants: variants,
  sizes: sizes,
  defaultProps: defaultProps
};
exports["default"] = Table;